import PrivateRouter from '@/onenetwork/layouts/PrivateRouter.vue'
import OneNetworkConfig from '@/onenetwork/core/onenetwork.config.ts'
import VersionManagement from '@/modules/setting/views/VersionManagement.vue'
import MembershipManagement from '@/modules/setting/views/MembershipManagement.vue'
import VersionDetail from '@/modules/setting/views/VersionDetail.vue'
import VersionCreate from '@/modules/setting/views/VersionCreate.vue'
import MembershipPlanCreate from '@/modules/setting/views/MembershipPlanCreate.vue'


const baseRoute = OneNetworkConfig.baseRoutePath
const systemRouter = [
  {
    path: `${baseRoute}/system/version`,
    name: 'system-version',
    meta: {
      component: VersionManagement
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/system/version/create`,
    name: 'version-create',
    meta: {
      component: VersionCreate
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/system/memberships`,
    name: 'system-memberships',
    meta: {
      component: MembershipManagement,
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/system/version/create`,
    name: 'membership-plan-create',
    meta: {
      component: MembershipPlanCreate
    },
    component: PrivateRouter,
  },
]
export default systemRouter
